import { render, staticRenderFns } from "./PresionArterial.vue?vue&type=template&id=3c051a67&scoped=true"
import script from "./PresionArterial.vue?vue&type=script&lang=js"
export * from "./PresionArterial.vue?vue&type=script&lang=js"
import style0 from "./PresionArterial.vue?vue&type=style&index=0&id=3c051a67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c051a67",
  null
  
)

export default component.exports